/* MONTTCO — We Are MonttCo desktop slide carousel (prev/next), ported from
   monttco-site/js/main.js's twStage logic. Mobile (<=640px) is a native
   swipe/scroll-snap row instead — no JS needed there, see the CSS. */
(function(){
  "use strict";
  var stage = document.getElementById('twStage');
  if (!stage) return;
  var slides = Array.prototype.slice.call(stage.querySelectorAll('.tw-slide'));
  var prevBtn = document.getElementById('twPrev');
  var nextBtn = document.getElementById('twNext');
  var idx = 0;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isMobile(){ return window.matchMedia('(max-width:640px)').matches; }

  function paint(){
    slides.forEach(function(slide, i){
      slide.classList.toggle('is-active', i === idx);
      slide.classList.toggle('is-exit', false);
    });
    if (prevBtn) prevBtn.disabled = idx <= 0;
    if (nextBtn) nextBtn.disabled = idx >= slides.length - 1;
  }
  function goTo(i){
    idx = Math.max(0, Math.min(slides.length - 1, i));
    paint();
  }

  if (prevBtn) prevBtn.addEventListener('click', function(){
    if (isMobile()){ stage.scrollBy({ left: -stage.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); return; }
    goTo(idx - 1);
  });
  if (nextBtn) nextBtn.addEventListener('click', function(){
    if (isMobile()){ stage.scrollBy({ left: stage.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); return; }
    goTo(idx + 1);
  });

  // Mobile: the strip scrolls natively, so follow it to keep prev/next state right.
  stage.addEventListener('scroll', function(){
    if (!isMobile()) return;
    idx = Math.round(stage.scrollLeft / (stage.clientWidth || 1));
    if (prevBtn) prevBtn.disabled = idx <= 0;
    if (nextBtn) nextBtn.disabled = idx >= slides.length - 1;
  }, { passive: true });

  paint();
})();
